import { useTranslation } from "react-i18next";
import Icon from "./Icon";
import ButtonSubmit from "./buttonSubmit";

const BoxStatisticsDowload = (props: any) => {
  let color = props.color ?? "rgb(95, 181, 235)";
  let icon = props.icon ?? "";

  const { t } = useTranslation();

  const downloadAgende = () => {
    window.open(process.env.REACT_APP_API + '/t4event/api/v01/federfarma/statistics/agenda/export', '_blank');

  }

  const downloadPharmacies = () => {
    window.open(process.env.REACT_APP_API + '/t4event/api/v01/federfarma/statistics/bookings/export', '_blank');
  }
  return (
    <div className="boxStatistics">
      <div className="d-inline-block">
        <div className="ball borderIcon" style={{ background: color }}>
          <Icon color={"#000"} icon={icon} />
        </div>
      </div>
      <div className="d-inline-block">
        <div className="col-12 mb-1">
          <ButtonSubmit
            handleChange={() => { downloadPharmacies() }}
            textButton={t('statistics.download-reservations')}

          />
        </div>
        <div className="col-12">
          <ButtonSubmit
            handleChange={() => { downloadAgende() }}
            textButton={t('statistics.download-agendas')}
          />
        </div>

      </div>
    </div>
  )
}

export default BoxStatisticsDowload